module.exports = __webpack_public_path__ + "static/media/u21a-c_05_v2.2dbb51f1.mp3";